import React from "react";
import { Container, Row, Col } from "reactstrap"; // Import Reactstrap components
import { Homesectionimage } from "../Data/ComponentsData/componentsdata";
import { Link } from "react-router-dom";
 


const HomeSection = () => {
  return (
    <section className='slide-bg' id='home'>
      <div className='animation-circle'>
        <i></i>
        <i></i>
        <i></i>
      </div>
      <Container>
        <Row>
          <Col md='6'>
            <div className='d-flex-1'>
              <div className='slide-text'>
                <div>
                  <h1>
                    The best way to connect with your friends is with
                    <span className='main-title'> ChatLoop!</span>
                  </h1>
                  <h4>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</h4>
                  <div className='slid-btn'>
                    <Link>
                      <img src='assets/images/app1.png' alt='app1' className='img-fluid' data-tilt data-tilt-perspective='50' data-tilt-speed='350' data-tilt-max='1.8' />
                    </Link>
                    <Link>
                      <img src='assets/images/app2.png' alt='app2' className='img-fluid' data-tilt data-tilt-perspective='50' data-tilt-speed='350' data-tilt-max='1.8' />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col md='6'>
            <div className='home-right'>             
              {Homesectionimage.map((image, index) => (
                <div key={index} className={image.class}>
                  <img src={image.src} alt={image.alt} className='img-fluid' />
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HomeSection;
